import { fetchContact as fetchContactCall } from 'flux/clients/messages2';

import ActionTypes from './ActionTypes';

export interface Actions {
  fetchContact: (arg: { id: string }) => void;
}

export default function actionsFactory(
  dispatch: (action: ActionTypes) => void,
): Actions {
  return {
    fetchContact: ({ id }) => {
      dispatch({ type: 'CONTACT:FETCHING', payload: { contactId: id } });

      fetchContactCall({ id })
        .then((result) =>
          dispatch({ type: 'CONTACT:FETCHING_SUCCESS', payload: { result } }),
        )
        .then((error) =>
          dispatch({ type: 'CONTACT:FETCHING_ERROR', payload: { error } }),
        );
    },
  };
}
